import React, { createContext, useContext, useReducer, useMemo } from 'react';
import type { CriteriaContextValuesType } from 'Components/widgets/criteria/CriteriaContext';
import 'Components/widgets/criteria/CriteriaContext';
export const ACTIONS = Object.freeze({
  CLOSE_CRITERIA: 'CLOSE_CRITERIA',
  OPEN_CRITERIA: 'OPEN_CRITERIA',
  OPEN_NEXT_CRITERIA: 'OPEN_NEXT_CRITERIA',
});
type Criteria = 'criteriaQuery' | 'criteriaWhen' | 'criteriaWho' | 'criteriaTransport';
export type State = {
  criteriaWhenIsOpen: boolean;
  criteriaWhoIsOpen: boolean;
  criteriaTransportIsOpen: boolean;
};
type OpenCriteriaAction = {
  type: 'OPEN_CRITERIA';
  payload: Criteria;
};
type CloseCriteriaAction = {
  type: 'CLOSE_CRITERIA';
  payload: Criteria;
};
type OpenNextCriteriaAction = {
  type: 'OPEN_NEXT_CRITERIA';
  payload: {
    currentCriteria: Criteria;
    criteriaContext: CriteriaContextValuesType;
  };
};
type Action = CloseCriteriaAction | OpenCriteriaAction | OpenNextCriteriaAction;
const initialState = {
  criteriaWhenIsOpen: false,
  criteriaWhoIsOpen: false,
  criteriaTransportIsOpen: false,
};

const criteriaContextReducer = (state: State, action: Action) => {
  switch (action.type) {
    case ACTIONS.OPEN_CRITERIA:
      return { ...state, [`${action.payload}IsOpen`]: true };

    case ACTIONS.CLOSE_CRITERIA:
      return { ...state, [`${action.payload}IsOpen`]: false };

    case ACTIONS.OPEN_NEXT_CRITERIA:
      const { currentCriteria, criteriaContext } = action.payload;

      if (currentCriteria === 'criteriaTransport') {
        return state;
      }

      if (currentCriteria === 'criteriaWho' && !criteriaContext.criteriaTransportIsSet) {
        return { ...state, criteriaTransportIsOpen: true };
      }

      if (currentCriteria === 'criteriaWhen') {
        if (!criteriaContext.criteriaWhoIsSet) {
          return { ...state, criteriaWhoIsOpen: true };
        }

        if (!criteriaContext.criteriaTransportIsSet) {
          return { ...state, criteriaTransportIsOpen: true };
        }
      }

      if (currentCriteria === 'criteriaQuery') {
        if (!criteriaContext.criteriaWhenIsSet) {
          return { ...state, criteriaWhenIsOpen: true };
        }

        if (!criteriaContext.criteriaWhoIsSet) {
          return { ...state, criteriaWhoIsOpen: true };
        }

        if (!criteriaContext.criteriaTransportIsSet) {
          return { ...state, criteriaTransportIsOpen: true };
        }
      }

      return state;

    default:
      return state;
  }
};

type CriteriaDisplayContextType = [State, (arg0: Action) => void];
export const CriteriaDisplayContext = createContext<CriteriaDisplayContextType>([
  initialState,
  () => {},
]);
export const useCriteriaDisplayContext = () => useContext(CriteriaDisplayContext);
export const CriteriaDisplayProvider = ({
  children,
  value = {},
}: {
  children: React.ReactNode;
  value?: Partial<State>;
}) => {
  const [state, dispatch] = useReducer(criteriaContextReducer, { ...initialState, ...value });
  const reducer = useMemo(() => [state, dispatch], [state, dispatch]);
  return (
    <CriteriaDisplayContext.Provider value={reducer}>{children}</CriteriaDisplayContext.Provider>
  );
};
